import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import Footer from "./components/Footer";
import Dashboard from "./components/Dashboard";
import Header from "./components/Header";
import { ChatProvider } from "./store/ChatContext";
import { AIChatPanel } from "./components/AIChatDrawer";
import PowerAppSolutions from "./components/PowerAppSolutions";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch("/auth/me", {
      credentials: "include",
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsAuthenticated(data.authenticated === true);
        setUser(data.authenticated ? data.user : null);
        setAuthChecked(true);
      })
      .catch(() => setAuthChecked(true));
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      fetch("/auth/me", {
        credentials: "include",
        cache: "no-store",
      })
        .then((res) => res.json())
        .then((data) => {
          setIsAuthenticated(data.authenticated === true);
          setUser(data.authenticated ? data.user : null);

          if (!data.authenticated) {
            // Session expired server-side — force logout
            window.location.href = "/auth/logout";
          }
        })
        .catch(() => {
          // Silent fail — don't log out on a transient network error
        });
    }, 60000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  const handleLogout = () => {
    setIsAuthenticated(false);
    window.location.href = "/auth/logout";
  };

  if (!authChecked) return null;

  return (
    <ChatProvider>
    <Router>
      <div
        className={`flex h-screen overflow-hidden ${isAuthenticated ? "bg-white" : "bg-gradient-to-br from-white via-blue-50 to-white"}`}
      >
        {/* Sidebar */}
        <Sidebar
          className="w-80 flex-shrink-0"
          isAuthenticated={isAuthenticated}
          onLogout={handleLogout}
          user={user}
        />

        {/* Right side content */}
        <div className="flex-1 h-screen overflow-y-auto">
          {/* Header */}
          {isAuthenticated && <Header userName={user?.name} />}

          <main className={`relative ${isAuthenticated ? "" : "p-6"}`}>
            <div
              className={`w-full min-h-full flex flex-col ${isAuthenticated ? "" : "bg-white rounded-xl shadow-lg"}`}
            >
              <Routes>
                <Route
                  path="/Hire360"
                  element={
                    !isAuthenticated ? (
                      <>
                        <HeroSection />
                        <FeaturesSection />
                        <Footer />
                      </>
                    ) : (
                      <Navigate to="/Hire360/Dashboard" replace />
                    )
                  }
                />

                {isAuthenticated && (
                  <>
                    <Route path="/Hire360/Dashboard" element={<Dashboard />} />
                    <Route path="/Hire360/launch-attract" element={<PowerAppSolutions solution="LaunchAttract" />} />
                    <Route path="/Hire360/screen-select" element={<PowerAppSolutions solution="ScreenSelect" />} />
                    <Route path="/Hire360/decide-offer" element={<PowerAppSolutions solution="DecideOffer" />} />
                    <Route path="/Hire360/verify-comply" element={<PowerAppSolutions solution="VerifyComply" />} />
                    <Route path="/Hire360/welcome-transition" element={<PowerAppSolutions solution="WelcomeTransition" />} />

                    {/* <Route path="/Hire360/time-keeper" element={<PowerAppSolutions solution="TimeKeeper" />} /> */}
                    <Route path="/Hire360/skip-line" element={<PowerAppSolutions solution="Skiptheline" />} />
                    <Route path="/Hire360/insights" element={<PowerAppSolutions solution="Insights" />} />
                  </>
                )}

                <Route
                  path="*"
                  element={
                    <Navigate
                      to={isAuthenticated ? "/Hire360/Dashboard" : "/Hire360"}
                    />
                  }
                />
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </Router>

    {user && <AIChatPanel user={user} />}
    </ChatProvider>
  );
};

export default App;
